import type { WidgetDef } from '@/types/dashboardConfig'
import { normalizePosition } from '@/dashboard/widgetGridStyle'

/** 每行/列格数；用于最小控件尺寸（MIN_FRAC = 1/12） */
const COLS = 12
/** 控件最小宽/高（1 列，即 1/12 面板宽）；开启网格吸附时使用 */
export const MIN_FRAC = 1 / COLS
/** 关闭网格吸附时的最小边长（比例），仍避免零距离控件 */
export const MIN_FRAC_FREE = 0.02

function rectsOverlap(
  ax: number, ay: number, aw: number, ah: number,
  bx: number, by: number, bw: number, bh: number,
): boolean {
  const EPS = 1e-6
  return ax < bx + bw - EPS && ax + aw > bx + EPS &&
         ay < by + bh - EPS && ay + ah > by + EPS
}

export function clampWidgetPosition(
  pos: { x: number; y: number; w: number; h: number },
  options?: { minFrac?: number },
) {
  let { x, y, w, h } = pos
  const minF = options?.minFrac ?? MIN_FRAC
  w = Math.min(Math.max(minF, w), 1)
  h = Math.min(Math.max(minF, h), 1)
  x = Math.min(Math.max(0, x), 1 - w)
  y = Math.min(Math.max(0, y), 1 - h)
  return { x, y, w, h }
}

export function canPlaceAt(
  widgets: WidgetDef[],
  x: number, y: number, w: number, h: number,
  excludeId?: string,
): boolean {
  const others = excludeId ? widgets.filter((o) => o.id !== excludeId) : widgets
  return !others.some((o) => {
    const p = normalizePosition(o.position)
    return rectsOverlap(x, y, w, h, p.x, p.y, p.w, p.h)
  })
}

export function findFreeCell(
  widgets: WidgetDef[],
  gw: number,
  gh: number,
  excludeId?: string,
  step?: number,
): { x: number; y: number } | null {
  const s = step ?? MIN_FRAC
  const others = excludeId ? widgets.filter((o) => o.id !== excludeId) : widgets
  for (let y = 0; y + gh <= 1 + 1e-6; y += s) {
    for (let x = 0; x + gw <= 1 + 1e-6; x += s) {
      const hit = others.some((o) => {
        const p = normalizePosition(o.position)
        return rectsOverlap(x, y, gw, gh, p.x, p.y, p.w, p.h)
      })
      if (!hit) return { x, y }
    }
  }
  return null
}
